import React, { useState } from 'react';
import {
  getRehydratableName,
  getClassNameFactory,
  Button,
  Responsive,
} from '@dcl/ui/';
import './index.css';
import { IModuleListProps, IModuleData } from './types';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';
import SubModule from './components/SubModule/SubModule';
import { DESKTOP_WIDTH } from '../UltraTaxCS/constants';
import { MOBILE_WIDTH } from '../TermsAndConditions/constants';
import MobileView from './components/MobileView';
import { convertDataToDropdownList } from './utils';
import './ModuleList.css';

export const ModuleList: React.FC<IModuleListProps> = (props) => {
  const {
    modulesData,
    showLessButtonLabel,
    showMoreButtonLabel,
    chooseASubjectLabel,
    goToSubjectLabel,
  } = props;
  const getClassName = getClassNameFactory(ModuleList.displayName);
  const [isExpanded, setIsExpanded] = useState(false);
  const itemsToShow = 5;

  const onShowMoreClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(ModuleList.displayName)}
      {...propsToDataAttributes(props)}
    >
      <Responsive minWidth={DESKTOP_WIDTH}>
        <div className={getClassName({ descendantName: 'container' })}>
          {modulesData
            ?.slice(0, isExpanded ? modulesData.length : itemsToShow)
            .map((moduleDataItem: IModuleData, index: number) => {
              const keyValue = `${moduleDataItem.url}${index + 1}`;
              return (
                <SubModule
                  key={keyValue}
                  text={moduleDataItem.title}
                  url={moduleDataItem.url}
                  newTab={moduleDataItem.newTab}
                ></SubModule>
              );
            })}
        </div>
        {modulesData.length > 5 ? (
          <div className={getClassName({ descendantName: 'buttonContainer' })}>
            <Button
              kind={ButtonKind.BUTTON}
              color={ButtonColor.SECONDARY}
              shape="circular"
              onClick={() => onShowMoreClick()}
            >
              {isExpanded ? showLessButtonLabel : showMoreButtonLabel}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </Responsive>
      <Responsive minWidth={0} maxWidth={MOBILE_WIDTH}>
        {modulesData.length ? (
          <MobileView
            modulesData={convertDataToDropdownList(modulesData)}
            chooseASubjectLabel={chooseASubjectLabel}
            goToSubjectLabel={goToSubjectLabel}
          ></MobileView>
        ) : (
          <></>
        )}
      </Responsive>
    </div>
  );
};

ModuleList.displayName = 'ModuleList';
